export default function AdminOverviewTab({ stats }) {
  if (!stats) return null;
  const rows = [
    ["Total users", stats.users],
    ["Customers", stats.customers],
    ["Active members", stats.active_members],
    ["Vendors", stats.vendors_total],
    ["Pending approval", stats.vendors_pending],
    ["Products", stats.products],
    ["Orders (paid)", stats.orders],
    ["GMV", `$${stats.gmv.toLocaleString()}`],
    ["Platform revenue (15%)", `$${stats.platform_revenue.toLocaleString()}`],
  ];
  return (
    <div className="grid md:grid-cols-4 gap-4" data-testid="admin-stats">
      {rows.map(([k, v], i) => (
        <div key={i} className="card-flat p-5" data-testid={`admin-stat-${i}`}>
          <p className="overline">{k}</p>
          <p className="font-display text-3xl mt-2">{v}</p>
        </div>
      ))}
    </div>
  );
}
